export default function HeroSection() {
  return (
    <div className="relative h-[45vh] min-h-[400px] overflow-hidden">
      <img 
        src="https://public.readdy.ai/ai/img_res/ad189a3cd9362bee96304e261edff11a.jpg"
        alt="USA Travel"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-slate-900/70 via-slate-900/50 to-slate-900/70"></div>
      
      <div className="absolute top-16 right-8 w-16 h-16 flex items-center justify-center opacity-20">
        <i className="ri-passport-line text-6xl text-white"></i>
      </div>
      
      <div className="relative h-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center">
        <div className="w-full max-w-3xl">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
            Visa, Thủ tục & Kinh nghiệm du lịch Mỹ
          </h1>
          <p className="text-lg md:text-xl text-white/90 font-light">
            Hướng dẫn chi tiết từ A-Z cho chuyến đi Mỹ của bạn
          </p>
        </div>
      </div>
    </div>
  );
}